<template>
  <div class="w-full h-full">
    <Transition name="slide-fade-course">
      <SelectCourse v-if="modalState === 'COURSE'" :onClickCourseCard="onClickCourseCard" />
    </Transition>
    <Transition name="slide-fade-challenge">
      <SelectChallenge v-if="modalState === 'CHALLENGE'" :onClickMiddleCl="onClickMiddleCl" />
    </Transition>
    <Transition name="slide-fade-bookmark">
      <SelectBookmark v-if="modalState === 'BOOKMARK'" :onClickBookmark="onClickBookmark" />
    </Transition>
    <Transition name="slide-fade-bookmark">
      <SelectCourseProblem v-if="modalState === 'COURSE_PROBLEM'" :onClickProblem="onClickProblem" />
    </Transition>
    <Transition name="slide-fade-bookmark">
      <SelectChallengeProblem v-if="modalState === 'CHALLENGE_PROBLEM'" :onClickProblem="onClickProblem" />
    </Transition>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import SelectBookmark from './SelectBookmark.vue'
import SelectChallenge from './SelectChallenge.vue'
import SelectChallengeProblem from './SelectChallengeProblem.vue'
import SelectCourse from './SelectCourse.vue'
import SelectCourseProblem from './SelectCourseProblem.vue'

import { useProblemSearchModalStatePresenter } from '@/presentation/composables/problem/useProblemSearchModalStatePresenter'

export default defineComponent({
  props: {
    onClickChallenge: {
      type: Function,
      required: true
    },
    onClickCourse: {
      type: Function,
      required: true
    },
    onClickCourseCard: {
      type: Function,
      required: true
    },
    onClickProblem: {
      type: Function,
      required: true
    },
    onClickMiddleCl: {
      type: Function,
      required: true
    },
    onClickBookmark: {
      type: Function,
      required: true
    }
  },
  components: {
    SelectCourse,
    SelectChallenge,
    SelectBookmark,
    SelectCourseProblem,
    SelectChallengeProblem
  },
  setup(props) {
    const problemSearchModalStatePresenter = useProblemSearchModalStatePresenter()

    return {
      modalState: problemSearchModalStatePresenter.modalState
    }
  }
})
</script>
<style lang="postcss" scoped>
.slide-fade-course-enter-active {
  transition: all 0.5s ease-out;
}

.slide-fade-course-enter-from,
.slide-fade-course-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.slide-fade-challenge-enter-active {
  transition: all 0.5s ease-out;
}

.slide-fade-challenge-enter-from,
.slide-fade-challenge-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.slide-fade-bookmark-enter-active {
  transition: all 0.5s ease-out;
}

.slide-fade-bookmark-enter-from,
.slide-fade-bookmark-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
